import { useSetRecoilState } from "recoil";
import { mobaCalendarListState } from "../../recoil/calendar/mobaCalendarListState";
import { RecurringOption, RecurringOptionType } from "../../types/block/enum";
import { BlockType } from "../../types/block/type";
import { optimisticBlockStore } from "../../services/block/optimisticBlockStore";
import { mergeClientServerBlocks } from "../../services/optimistic-updates/block-merger";

function useHandleClientBlockStateDelete() {
  const setMobaCalendarList = useSetRecoilState(mobaCalendarListState);

  const handleClientBlockDelete = ({
    updateBlockData,
    recurringOption,
  }: {
    updateBlockData: BlockType;
    recurringOption?: RecurringOptionType;
  }) => {
    if (recurringOption === RecurringOption.ALL) {
      const { originalId } = updateBlockData;
      setMobaCalendarList((current) => {
        const updatedEvents = current.filter((event) => {
          const isRecurringBlock = event.originalId === originalId; // 같은 모체의 반복 인스턴트인 경우

          return !isRecurringBlock;
        });
        return updatedEvents;
      });
      return;
    }

    if (recurringOption === RecurringOption.THISANDAFTER) {
      const { start, originalId, originalStart } = updateBlockData;
      const eventStartDate = originalStart ?? start;

      if (!eventStartDate) return;

      const selectedEventStart = new Date(eventStartDate).getTime();

      setMobaCalendarList((current) => {
        const updatedEvents = current.filter((event) => {
          if (!event.start) return event;

          const eventStart = new Date(event.start).getTime();
          const isRecurringBlock = event.originalId === originalId; // 같은 모체의 반복 인스턴트인 경우
          const isAfterSelectedEvent = selectedEventStart <= eventStart;

          return !(isRecurringBlock && isAfterSelectedEvent);
        });
        return updatedEvents;
      });
      return;
    }

    // NOTE 일반블록 delete 처리 낙관적 업데이트 로직
    const optimisticBlockData = {
      ...updateBlockData,
      updatedAt: new Date().toISOString(),
    };

    optimisticBlockStore.add({
      id: updateBlockData.id,
      data: optimisticBlockData,
      isDeletedBlock: true,
    });

    setMobaCalendarList((prev) => [
      ...mergeClientServerBlocks(prev, optimisticBlockStore.getAll()),
    ]);
  };

  return { handleClientBlockDelete };
}

export default useHandleClientBlockStateDelete;
